import { render } from "./MultilingualQuill.vue?vue&type=template&id=1e974836"
import script from "./MultilingualQuill.vue?vue&type=script&lang=js"
export * from "./MultilingualQuill.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/components/MultilingualQuill.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e974836"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e974836', __exports__)) {
    api.reload('1e974836', __exports__)
  }
  
  module.hot.accept("./MultilingualQuill.vue?vue&type=template&id=1e974836", () => {
    api.rerender('1e974836', render)
  })

}


export default __exports__